import { useLocation } from "react-router";
import ResetPassword from "../components/Login/ResetPassword";
import "./LoginForm.scss"
function ResetPasswordPage (){
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return (
        <div className="login-form">
            <h4 ><a href="/"><img src="/assets/logo-tiny.png" width="50" height="50" alt="push asso" /></a></h4>
            <ResetPassword token={params.get('hash')} />
        </div>
    );

}

export default ResetPasswordPage;